import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../../common/global-constants";
import { BOOdontologyTissueType } from "../../models/odo/BOOdontologyTissueType.model";

@Injectable({
  providedIn: 'root'
})

export class OdontologyTissueTypeService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/OdontologyTissueType';

    constructor(private http:HttpClient){}

    getAll():Observable<BOOdontologyTissueType[]>{
        return this.http.get<BOOdontologyTissueType[]>(this.myAppUrl + this.myApiUrl);
    }


  }
